<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-select
                    :options="form.anos"
                    :validations="validations.ano"
                    @change="handleAnoChange"
                    label="Ano"
                    v-model="model.ano"
                />
            </rkm-col>

            <rkm-col cols="5">
                <rkm-form-select
                    :options="form.competencias"
                    :validations="validations.competencia"
                    @change="handleCompetenciaChange"
                    label="Mês"
                    show-default-option
                    text-field="mes"
                    v-model="model.competenciaId"
                    value-field="id"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-select
                    :options="form.cnes"
                    :validations="validations.cnes"
                    @change="handleCnesChange"
                    show-default-option
                    label="CNES"
                    v-model="model.cnes"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-select
                    :options="form.unidades"
                    default-option-text="Todas"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.unidadeId"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        validations() {
            return {
                ano: { required: true },
                competencia: { required: true },
                cnes: { required: true },
            }
        },
    },
    created() {
        this.repositories = {
            procedimentoIndividualizado: this.getConectaSusRepository('bpa.procedimentoIndividualizado'),
        }
    },
    data: () => ({
        form: {},
        model: {},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            const request = { acao: 'exclusao' }

            this.repositories.procedimentoIndividualizado.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        destroy() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        const destroy = async () => {
                            this.setLoading()

                            this.repositories.procedimentoIndividualizado.store(this.camelObjectKeysToSnakeRecursive(this.model))
                                .then(response => {
                                    this.showSaveNotification()
                                    this.$emit('save', response)
                                })
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading())
                        }

                        if (!this.model.unidadeId && this.form.unidades.length > 1) {
                            this.showConfirmation(
                                `O CNES selecionado possui mais de uma unidade vinculada. Ao continuar, a exclusão será realizada
                                considerando todas as unidades para este CNES na competência selecionada. Deseja continuar?`,
                                destroy
                            )

                            return
                        }

                        destroy()
                    }
                })
        },
        handleAnoChange() {
            this.form.competencias = []
            this.form.cnes = []
            this.form.unidades = []
            this.model.competenciaId = null
            this.model.cnes = null
            this.model.unidadeId = null

            const params = {
                origem: 'exclusao',
                listar: 'competencias',
                ano: this.model.ano,
            }

            this.setLoading()

            this.repositories.procedimentoIndividualizado.list(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    this.form.competencias = data.competencias
                    this.form.cnes = data.cnes
                    this.form.unidades = data.unidades
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCompetenciaChange() {
            this.form.cnes = []
            this.form.unidades = []
            this.model.cnes = null
            this.model.unidadeId = null

            if (!this.model.competenciaId) return

            const params = {
                origem: 'exclusao',
                listar: 'cnes',
                competenciaId: this.model.competenciaId,
            }

            this.setLoading()

            this.repositories.procedimentoIndividualizado.list(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    this.form.cnes = data.cnes
                    this.form.unidades = data.unidades
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCnesChange() {
            this.form.unidades = []
            this.model.unidadeId = null

            if (!this.model.cnes) return

            const params = {
                origem: 'exclusao',
                listar: 'unidades',
                competenciaId: this.model.competenciaId,
                cnes: this.model.cnes,
            }

            this.setLoading()

            this.repositories.procedimentoIndividualizado.list(this.camelObjectKeysToSnakeRecursive(params))
                .then(({ data }) => {
                    this.form.unidades = data.unidades

                    if (this.form.unidades.length === 1) {
                        this.model.unidadeId = this.form.unidades[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
}
</script>